import { DirtyComponent } from '@ngneat/dirty-check-forms';
import { of, take, defer, switchMap, Observable, isObservable } from 'rxjs';

import { inject } from '@angular/core';
import { CanDeactivateFn, ActivatedRouteSnapshot } from '@angular/router';

import { AppDialog } from '@/app/shared/components/ui/dialog';
import { ConfirmDialogComponent } from '@/app/shared/components/ui/confirm-dialog';

function toObservable<T>(source: T | Observable<T>): Observable<T> {
  return isObservable(source) ? source : of(source);
}

export const dirtyFormGuard: CanDeactivateFn<DirtyComponent> = (component, currentRoute, currentState, nextState) => {
  const dialog = inject(AppDialog);

  let dirty$: Observable<boolean>;
  const componentDirty = component.isDirty$;

  if (typeof componentDirty === 'function') {
    dirty$ = defer(() => toObservable(componentDirty()));
  } else {
    dirty$ = toObservable(componentDirty);
  }

  const confirmChanges = (currentRoute: ActivatedRouteSnapshot): Observable<boolean> | boolean => {
    const dialogRef = dialog.open(ConfirmDialogComponent, {
      data: {
        type: 'warning',
        title: 'Are you sure you want to discard changes?',
        acceptButtonProps: {
          label: 'Yes',
          variant: 'primary-outlined',
        },
      },
    });

    return dialogRef.closed;
  };

  return dirty$.pipe(
    switchMap((isDirty) => {
      if (isDirty === false) {
        return of(true);
      }
      return toObservable(confirmChanges(currentRoute));
    }),
    take(1),
  );
};
